export interface PageableListDto<T> {
  items: T[];
  lastIndexKey?: number;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  lastOrderKey?: any;
  isEndReached: boolean;
}
